import classNames from 'classnames'

import { MONTHS } from '../constants'

import styles from './MonthAndYearList.module.scss'

interface IMonthList {
  selectMonth: string
  filter: string
  onSelectMonthChanged: (newMonth: string) => void
}

export const MonthList = ({ selectMonth, onSelectMonthChanged, filter }: IMonthList) => {
  const visibleMonths = [...MONTHS].filter((m) => {
    if (!filter || selectMonth === filter) {
      return m
    }
    return m.toLowerCase().startsWith(filter.toLowerCase())
  })
  return (
    <div className={styles.root}>
      {visibleMonths.map((month) => {
        const isActive = selectMonth === month
        return (
          <div
            key={month}
            className={classNames(styles.item, isActive ? styles['item--active'] : '')}
            onClick={() => onSelectMonthChanged(month)}
            tabIndex={0}
          >
            {month}
          </div>
        )
      })}
    </div>
  )
}
